import { MenuItem, useDisclosure } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import {
  useSendProformaBulkMutation,
  useSendProformaMutation,
} from "@src/__generated__/graphql";
import { ModalConfirm } from "@src/components/ui-kit";
import { onError } from "@src/utils/apollo";
import { observer } from "mobx-react-lite";
import React, { type FC } from "react";
import { useStore } from "../../store";

interface ResendActionProps {
  id: string | string[];
}

export const ResendAction: FC<React.PropsWithChildren<ResendActionProps>> =
  observer(function ResendAction({ id }) {
    const store = useStore();
    const modal = useDisclosure();

    const [sendProformaMutation] = useSendProformaMutation({
      onCompleted() {
        store.proformaInvoicesRefetch?.();
      },
      ...onError(),
    });
    const [sendProformaBulkMutation] = useSendProformaBulkMutation({
      onCompleted() {
        store.proformaInvoicesRefetch?.();
      },
      ...onError(),
    });

    const resendAction = () => {
      if (Array.isArray(id)) {
        id.length &&
          sendProformaBulkMutation({
            variables: { ids: id },
          });
      } else if (id) {
        sendProformaMutation({
          variables: { id },
        });
      }
    };

    const isDisabled = Array.isArray(id) ? !id.length : !id;

    return (
      <React.Fragment>
        <MenuItem isDisabled={isDisabled} onClick={modal.onOpen}>
          <Trans>Resend invoice</Trans>
        </MenuItem>
        <ModalConfirm onConfirm={resendAction} {...modal} />
      </React.Fragment>
    );
  });
